import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import CSSModules from "lib/utils/css-modules";
import { st, Form, FormMessage, FormControl, HintView } from "lib/index";
import { updateProduct, validate, save } from "../index";
import Hint from "./StepAdditionalHint";

@connect(
  (state) => ({
    product: state.products.EditProductView.product,
    submitLoading: state.products.EditProductView.submitLoading,
    valid: state.products.EditProductView.valid,
    errors: state.products.EditProductView.errors,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        updateProduct,
        validate,
        save,
      },
      dispatch
    )
)
export default class StepAdditionalForm extends React.PureComponent {
  handleSubmit(event) {
    const { save } = this.props;
    event.preventDefault();
    save();
  }

  handleProductPropChange(prop, value) {
    const { product, updateProduct } = this.props;
    updateProduct({
      ...product,
      [prop]: value,
    });
  }

  render() {
    const { product, readOnlyAccess, submitLoading, valid, errors, validate } = this.props;
    const onBlur = validate;

    return (
      <HintView.Container>
        <HintView.Content></HintView.Content>
        <HintView.Sidebar>
          <Hint />
        </HintView.Sidebar>
      </HintView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepAdditional/StepAdditionalForm.jsx